import Model, { attr } from '@ember-data/model';
import { cached } from '@glimmer/tracking';

export enum AssignmentRuleKind {
  cleaning = 'cleaning',
  maintenance = 'maintenance',
}

export enum AssignmentRuleMode {
  pool = 'pool',
  ordered = 'ordered',
  manual = 'manual',
}

export interface IRotationEntry {
  user_id: number;
  name: string | null;
  source: 'explicit' | 'derived';
  position: number;
  offers_received?: number;
  offers_accepted?: number;
  average_on_site_minutes?: number | null;
}

export interface IPausedMember {
  user_id: number;
  name: string | null;
}

export default class AssignmentRuleModel extends Model {
  @attr('string') kind!: AssignmentRuleKind;
  @attr('string', { defaultValue: AssignmentRuleMode.pool })
  mode!: AssignmentRuleMode;

  @attr('number', { defaultValue: 1 }) requiredAcceptances!: number;
  @attr('number') propertyId!: number;

  @attr('array') multiUnitIds!: number[];
  @attr('array') rotation!: IRotationEntry[];
  @attr('array') inactiveUserIds!: number[];
  @attr('array') paused!: IPausedMember[];

  @cached
  get isPersisted(): boolean {
    return !!this.id;
  }

  @cached
  get isOrdered(): boolean {
    return this.mode === AssignmentRuleMode.ordered;
  }

  @cached
  get isManual(): boolean {
    return this.mode === AssignmentRuleMode.manual;
  }

  @cached
  get sortedRotation(): IRotationEntry[] {
    return [...(this.rotation ?? [])].sort((a, b) => a.position - b.position);
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'assignment-rule': AssignmentRuleModel;
  }
}
